import { createSlice, PayloadAction } from '@reduxjs/toolkit'

interface ReduxStatePhone {
  verification_id?: string
  verification_code?: string
}

const initialState: ReduxStatePhone = {}

const phoneSlice = createSlice({
  name: 'PHONE',
  initialState,
  extraReducers: {
    // [appTypes.RESET]: (state, action) => {
    //   return initialState
    // },
  },
  reducers: {
    setVerification(state, action: PayloadAction<Pick<ReduxStatePhone, 'verification_code' | 'verification_id'>>) {
      let { verification_code, verification_id } = action.payload
      state.verification_id = verification_id
      state.verification_code = verification_code
    },
  },
})

export const { actions, reducer } = phoneSlice
export default reducer
